/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UserNotificationPatch } from '../models/UserNotificationPatch';
import type { UserNotifications } from '../models/UserNotifications';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UserNotificationService {
    /**
     * Get User Notifications
     * @returns UserNotifications Successful Response
     * @throws ApiError
     */
    public static getUserNotificationsUserNotificationGet(): CancelablePromise<UserNotifications> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user_notification/',
        });
    }
    /**
     * Patch User Notifications
     * @param requestBody
     * @returns UserNotifications Successful Response
     * @throws ApiError
     */
    public static patchUserNotificationsUserNotificationPatch(
        requestBody: UserNotificationPatch,
    ): CancelablePromise<UserNotifications> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/user_notification/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
